import * as React from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Grid, GridColumn as Column, GridCell, GridSortChangeEvent } from '@progress/kendo-react-grid';
import { fetchApi } from '../../services/api';
import { SortDescriptor, orderBy } from '@progress/kendo-data-query';

type Props = RouteComponentProps<{
    accountId: string;
 }>;

type State = {
    sort: SortDescriptor[];
    accountId: number;
    invoices: Invoice[];
    errors: AlertData[];
    isLoading: boolean;
}

interface Invoice {
    AltInvoiceNum: string;
    InvoiceID: number;
    InvoiceNumber: number;
    BillingPeriodID: number;
    BillingPeriodName: string;
    AccountID: number;
    Date: Date;
    Amount: Number;
}

type AlertData = {
    Message: string;
    Link: string;
}

class InvoiceNumberCell extends GridCell {
    render() {
        if (this.props.dataItem.InvoiceID) {
            return (
                <td>
                    <Link style={{ color: '#007bff' }} to={ `/invoice/${ this.props.dataItem.InvoiceID }` }>
                        {this.props.dataItem.InvoiceNumber}
                    </Link>
                </td>
            );
        } else {
            return (
                <td>
                    <Link style={{ color: '#007bff' }} to={ `/accounts/${ this.props.dataItem.AccountID }/invoices/${ this.props.dataItem.BillingPeriodID }` }>
                        {this.props.dataItem.InvoiceNumber}
                    </Link>
                </td>
            );
        }
    }
}

export default class AccountInvoices extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);
        this.state = {
            accountId: 0,
            invoices: [],
            errors: [],
            isLoading: false,
            sort: [{field: "BillingPeriodName", dir: "asc"}],
        };

        this.sortChange = this.sortChange.bind(this);
        this.getInvoices = this.getInvoices.bind(this)
    }

    public componentWillMount() {
        // This method runs when the component is first added to the page
        let accountId = parseInt(this.props.match.params.accountId) || 0;
        this.getInvoices(accountId);
    }

    public componentWillReceiveProps(nextProps: Props) {
        // This method runs when incoming props (e.g., route params) change
        let accountId = parseInt(nextProps.match.params.accountId) || 0;

        if (this.state.invoices && this.state.accountId != accountId) {
            this.getInvoices(accountId);
        }
    }

    public render() {
        return <div>
            <br />
            {this.state.errors.map((error, index) => {
                return <div className="alert alert-danger d-print-none" key={index}>
                    {error.Message}&nbsp;
                    {error.Link && <Link to={error.Link} className="alert-link">Fix Here</Link>}
                </div>
            })}
            <Grid data={this.state.invoices}
                sortable={{
                    allowUnsort: true
                }}
                sort={this.state.sort}
                onSortChange={this.sortChange}
                pageable={{
                    buttonCount: 0,
                    info: true,
                    type: 'numeric',
                    pageSizes: false,
                    previousNext: false
                }}
                skip={0}
                take={this.state.invoices.length}
                total={this.state.invoices.length}
            >
                <Column field="InvoiceID" title="#" cell={InvoiceNumberCell} />
                <Column field="AltInvoiceNum" title="Alt #" />
                <Column field="BillingPeriodName" title="Period" />
                <Column field="Amount" filter="numeric" format="{0:c}" />
            </Grid>
        </div>;
    }

    private sortChange(event: GridSortChangeEvent) {
        this.setState({
            sort: event.sort,
            invoices: orderBy(this.state.invoices, event.sort)
        });
    }

    private getInvoices(accountId: number) {
        this.setState({ isLoading: true, accountId });
        const data = {
            FacilityID: localStorage.getItem("FACILITY_ID"),
            AccountID: accountId
        }
        if (data.FacilityID) {
            fetchApi(`api/Account/Invoices`, data, 'POST')
                .then((invoices: Invoice[]) => {
                    this.setState({ isLoading: false, invoices });
                });
        } else {
            this.setState({ errors: [{ Message: 'Please select a facility first, using the dropdown above.', Link: '' }] });
        }
    }
}
